import intersectionBy from "lodash.intersectionby";

import { isEmptyObject } from "@utils/types";
import shuffle from "@utils/shuffle";
import store from "@store";
import { db } from "@src/firebase.config";
import { app } from "../flamelink";

const matchmaker = async refs => {
  if (!refs.length) return [];

  const matches = await app.content.get({
    schemaKey: "brand",
    fields: ["brandName", "thumbnailImage", "url", "tags", "id"],
    populate: ["thumbnailImage"],
    filters: [["tags", "array-contains-any", refs]]
  });

  return matches === null ? [] : Object.values(matches);
};

let uuid = 0;

export default async () => {
  const thisId = (uuid += 1);

  // Cache value
  const { active } = store.state.directory;

  if (isEmptyObject(active)) return null;

  // Create and array of references for each filter type
  const activeArray = Object.values(active);

  let departmentRefs = [];
  let categoryRefs = [];
  let continentRefs = [];

  for (let i = 0, len = activeArray.length; i < len; i++) {
    switch (activeArray[i].type) {
      case "department":
        departmentRefs.push(db.collection("fl_content").doc(activeArray[i].id));
        break;
      case "category":
        categoryRefs.push(db.collection("fl_content").doc(activeArray[i].id));
        break;
      case "continent":
        continentRefs.push(db.collection("fl_content").doc(activeArray[i].id));
        break;
    }
  }

  // Request concurrently
  // Get matches
  const departmentMatchesReq = matchmaker(departmentRefs);
  const categoryMatchesReq = matchmaker(categoryRefs);
  const continentMatchesReq = matchmaker(continentRefs);

  const departmentMatches = await departmentMatchesReq;
  const categoryMatches = await categoryMatchesReq;
  const continentMatches = await continentMatchesReq;

  // If there is a newer request throw this one away
  if (thisId !== uuid) return null;

  // AND the matches
  const results = intersectionBy(
    ...(departmentMatches.length ? [departmentMatches] : []),
    ...(categoryMatches.length ? [categoryMatches] : []),
    ...(continentMatches.length ? [continentMatches] : []),
    "id"
  );

  // Shuffle them for fairness
  shuffle(results);

  // Score the results set
  for (let i = 0, len = results.length; i < len; i++) {
    const matches = intersectionBy(results[i].tags, activeArray, "id");
    results[i].score = matches.length;
  }

  //Sort them by score
  results.sort((a, b) => b.score - a.score);

  return results;
};
